<template>
  <b-card>
    <b-form @submit.prevent>
      <b-row align-v="center">
        <b-col
          cols="12"
          sm="3"
        >
          <b-form-group
            label-for="Origen"
            label="Origen"
          >
            <v-select
              v-model="city_origen"
              :filterable="false"
              :options="rowCityOrigen"
              name="city"
              label="name"
              placeholder="Ciudad de origen"
              @search="onSearchOrigin"
            >
              <template #option="{ name }">
                <h6>{{ formatName(name) }}</h6>
              </template>
              <template #selected-option="{ name }">
                <div style="display: flex; align-items: baseline">
                  {{ formatName(name) }}
                </div>
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  No existe la ciudad <em>{{ search }}</em>.
                </template>
                <em
                  v-else
                  style="opacity: 0.5"
                >
                  Comience a escribir para buscar una ciudad.
                </em>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="3"
        >
          <b-form-group
            label-for="Destino"
            label="Destino"
          >
            <v-select
              v-model="city_destino"
              :filterable="false"
              :options="rowCityDestino"
              name="city"
              label="name"
              placeholder="Ciudad de destino"
              @search="onSearchDestination"
            >
              <template #option="{ name }">
                <h6>{{ formatName(name) }}</h6>
              </template>
              <template #selected-option="{ name }">
                <div style="display: flex; align-items: baseline">
                  {{ formatName(name) }}
                </div>
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  No existe la ciudad <em>{{ search }}</em>.
                </template>
                <em
                  v-else
                  style="opacity: 0.5"
                >
                  Comience a escribir para buscar una ciudad.
                </em>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="2"
        >
          <b-form-group
            label="Fecha de salida"
            label-for="Fecha de salida"
          >
            <VueDatePicker
              v-model="date_of_salida"
              :allowed-dates="allowedDates"
              fullscreen-mobile
              placeholder="Fecha de salida"
              color="#152848"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="2"
        >
          <b-form-group
            label="Fecha de regreso"
            label-for="Fecha de regreso"
          >
            <VueDatePicker
              v-model="date_of_regreso"
              :allowed-dates="allowedDatesComeBack"
              fullscreen-mobile
              placeholder="Opcional"
              color="#152848"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="2"
          class="mb-50"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            :disabled="loading || city_origen === null || city_destino === null || date_of_salida === null"
            variant="primary"
            class="mt-0 mt-md-3"
            block
            @click="send"
          >
            <span class="align-middle">BUSCAR</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { BCol, BRow, BForm, BFormGroup, BFormInput, BInputGroup,
  BInputGroupPrepend, BButton, BCard } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import 'regenerator-runtime'
import axios from 'axios'
import 'vue-select/dist/vue-select.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { VueDatePicker } from '@mathieustan/vue-datepicker'
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css'
export default {
  name: 'FormSearchTicket',
  components: {
    BCol,
    BRow,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BCard,
    VueDatePicker,
    vSelect
  },
  directives: {
    Ripple
  },
  data () {
    return {
      date_of_salida: null,
      date_of_regreso: null,
      city_origen: null,
      city_destino: null,
      rowCityOrigen: [],
      rowCityDestino: []
    }
  },
  methods: {
    capitalize (word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase()
    },
    allowedDates (date) {
      // Get current date in Colombia timezone (UTC-5)
      const now = new Date()
      const colombiaTime = new Date(now.getTime() - (5 * 60 * 60 * 1000)) // UTC-5
      const today = colombiaTime.toISOString().substring(0, 10)
      return today <= date
    },
    allowedDatesComeBack (date) {
      const today = this.date_of_salida
      return today < date
    },
    onSearchOrigin (search, loading) {
      if (search.length) {
        loading(true)
        this.getCityOrigen(search.toLowerCase(), loading)
      }
    },
    onSearchDestination (search, loading) {
      if (search.length) {
        loading(true)
        this.getCityDestino(search.toLowerCase(), loading)
      }
    },
    async getCityOrigen (search, loading) {
      this.rowCityOrigen = await axios.get('https://api.old-web.travelbus.com.co/api/v1/city', {
        params: {
          search
        }
      }).then(function (response) {
        loading(false)
        return response.data.data
      }).catch(function (error) {
        console.log(error)
      })
    },
    async getCityDestino (search, loading) {
      this.rowCityDestino = await axios.get('https://api.old-web.travelbus.com.co/api/v1/city', {
        params: {
          search,
          not_city: this.city_origen.id
        }
      }).then(function (response) {
        loading(false)
        return response.data.data
      }).catch(function (error) {
        console.log(error)
      })
    },
    send () {
      window.open(`https://tiquetes.old-web.travelbus.com.co/?cityOrigin=${this.city_origen.id}&cityDestination=${this.city_destino.id}&dateOrigin=${this.date_of_salida}&dateDestination=${this.date_of_regreso}`)
    },
    formatName (name) {
      return name.replace(/\b\w/g, char => char.toUpperCase()).replace(/\(([^)]+)\)/g, (_, inside) => `(${inside.toUpperCase()})`)
    }
  }
}
</script>
<style>
.vd-picker__input {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  padding: 0.1rem 0.7rem;
}
.vs__selected-options {
  padding: 3px 2px !important;
}
.btn-primary {
  border-color: #152848 !important;
  background-color: #152848 !important;
}
input[type=search] {
  border: none !important;
  background: none !important;
  padding: 0px !important;
}
.btn-block {
  width: 100%;
}
</style>
